/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The LegalEntityCompanyPostRequestDTO model module.
 * @module model/LegalEntityCompanyPostRequestDTO
 * @version v0
 */
export class LegalEntityCompanyPostRequestDTO {
  /**
   * Constructs a new <code>LegalEntityCompanyPostRequestDTO</code>.
   * @alias module:model/LegalEntityCompanyPostRequestDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntityCompanyPostRequestDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntityCompanyPostRequestDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntityCompanyPostRequestDTO} The populated <code>LegalEntityCompanyPostRequestDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntityCompanyPostRequestDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('authorityCode'))
        obj.authorityCode = ApiClient.convertToType(data['authorityCode'], 'String');
      if (data.hasOwnProperty('legalEntitySubsidiaryId'))
        obj.legalEntitySubsidiaryId = ApiClient.convertToType(data['legalEntitySubsidiaryId'], 'Number');
      if (data.hasOwnProperty('legalEntityRegionId'))
        obj.legalEntityRegionId = ApiClient.convertToType(data['legalEntityRegionId'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntityCompanyPostRequestDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
LegalEntityCompanyPostRequestDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
LegalEntityCompanyPostRequestDTO.prototype.active = undefined;

/**
 * @member {String} authorityCode
 */
LegalEntityCompanyPostRequestDTO.prototype.authorityCode = undefined;

/**
 * @member {Number} legalEntitySubsidiaryId
 */
LegalEntityCompanyPostRequestDTO.prototype.legalEntitySubsidiaryId = undefined;

/**
 * @member {Number} legalEntityRegionId
 */
LegalEntityCompanyPostRequestDTO.prototype.legalEntityRegionId = undefined;

